import type { ApiConfig } from '../declare'

const apis: ApiConfig[] = [
  {
    name: 'getChartPageConfigInfo',
    method: 'POST',
    path: '/PF/PageChart/GetChartPageConfigInfo',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '获取图表表单配置信息'
  },
]

export default apis